// extracted by mini-css-extract-plugin
export default {"modal":"Dka-z","header":"Eka-z","fields":"Fka-z","error":"Gka-z","disabled":"Hka-z","reminderMsg":"Ika-z","errorMsg":"Jka-z","footer":"Kka-z"};